import React, { useEffect, useState } from 'react';
import { useParams} from 'react-router-dom';
import LinkifyText from './LinkifyText.js';
import { Link } from "react-router-dom";
import { API_BASE_URL } from '../scripts/control';

const ProjectDetail = () => {
    const { idproject } = useParams(); // Obtenida de la URL
    const [project, setProject] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/details.php?type=project&id=${idproject}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setError(data.error);
                } else {
                    setProject(data);
                }
            })
            .catch((error) => setError('Error al obtener los detalles del proyecto.'));
    }, [idproject]);

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!project) {
        return <div>Cargando detalles del proyecto...</div>;
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="card" style={{ maxWidth: '900px', margin: '20px auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <div className="card-body m-2">
                <h1 className="card-title">{project.title}</h1>
                <img
                    src={project.img_url 
                            ? `${API_BASE_URL}/public/uploads/images/${project.img_url}` 
                            : `${API_BASE_URL}/public/uploads/images/comic.jpg`}
                    alt={project.img_alt || 'Imagen del proyecto'}
                    style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', marginBottom: '20px', marginLeft: '-2%' }}
                />
                <LinkifyText text={project.body} />
                
                {project.location && (
                    <p className="card-text">
                        <strong>Ubicación:</strong> {project.location || 'No especificada'}
                    </p>
                )}
                
                {project.day && project.day !== '0000-00-00' && (
                    <p className="card-text">
                        <strong>Fecha:</strong> {formatDate(project.day)}
                    </p>
                )}

                {project.hour && project.hour !== '00:00:00' && (
                    <p className="card-text">
                        <strong>Hora:</strong> {project.hour || 'No especificada'}
                    </p>
                )}

                {project.link && 
                <Link to={`${project.link}`} target='blank'>
                    <button
                            className="btn btn-primary"
                            style={{
                                marginRight: '10px',
                                marginBottom: '10px',
                                padding: '5px 10px',
                                backgroundColor: '#005EC4',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}
                        >
                            Ir al proyecto
                    </button>
                </Link>
                }

                <button
                    className="btn btn-primary"
                    style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#005EC4', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                     onClick={scrollToTop}
                >
                    Subir
                </button>
            </div>
        </div>
    );
};

export default ProjectDetail;
